/* デジタルクーポン区分 */
export default {
    // デジタルクーポン
    DIGITAL_COUPON: "10",
    // デジタルクーポン(バーコード)
    DIGITAL_COUPON_BARCODE: "20"
}